var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.93 16.85a31 31 0 0 0-43.83 0 1.75 1.75 0 0 0 2.48 2.47 27.52 27.52 0 0 1 38.88 0 1.73 1.73 0 0 0 1.23.51 1.75 1.75 0 0 0 1.24-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.56a23.51 23.51 0 0 0-16.77 7A1.75 1.75 0 1 0 10.72 27a20.22 20.22 0 0 1 28.59 0 1.75 1.75 0 0 0 2.47-2.47A23.51 23.51 0 0 0 25 17.56Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.35 32a1.75 1.75 0 0 0 2.48 2.47 11.6 11.6 0 0 1 16.38 0 1.74 1.74 0 0 0 1.23.52 1.76 1.76 0 0 0 1.24-3 15.1 15.1 0 0 0-21.33.01Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.02,
    cy: 39.98,
    r: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/icon_wifi.4cf64359cdb55e9615e5ca6b13096245.svg";
export { ForwardRef as ReactComponent };